module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.onInput],
      "focus": _vm.onFocus
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "h8 regular c-dgrey upcase"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', {
    staticClass: "input-text_info h8 regular upcase error",
    class: {
      active: _vm.errorVisible && _vm.errorMessage !== null
    }
  }, [_vm._v("\n\t\t\t  " + _vm._s(_vm.errorMessage) + "\n\t\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f262a8b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/InputText.vue
// module id = 667
// module chunks = 0